<template>
  <div class="hh-padlock-wrapper">
    <div class="hh-lock-capsule" v-if="!isUnlocked" v-longclick="processLongClick">
      <div v-show="!unLocking" class="hh-circle-icon"/>
      <loading-animation v-show="unLocking" :height="33" :width="33" type="spinner"/>
      <span class="hh-lock-text">Click and hold to edit</span>
    </div>
    <div v-longclick="processLongClick" class="margin-right-15">
      <img v-if="isUnlocked" class="hh-padlock" src="/dist/site/static/icons/padlock-unlocked.svg"
           alt="Unlocked Icon">
      <img v-if="!isUnlocked" :class="unLocking ? 'hh-padlock-continuous-shake' : 'hh-padlock-default-shake'"
           class="hh-padlock" src="/dist/site/static/icons/padlock-locked.svg" alt="Locked Icon">
    </div>
  </div>
</template>

<script>
import LoadingAnimation from '../LoadingAnimation'

export default {
  name: "ClickToUnlock",

  props: {
    redirectTo: String,
  },

  components: {
    LoadingAnimation
  },

  data() {
    return {
      longClickEvents: 0,
      isUnlocked: false,
    }
  },

  methods: {
    processLongClick() {
      if (this.isUnlocked) return

      if (this.longClickEvents > 30) {
        this.longClickEvents = -1
        this.unlock()

      } else {
        this.longClickEvents += 1
        let currentClickEvents = this.longClickEvents
        setTimeout(() => {
          if (this.longClickEvents === currentClickEvents) {
            this.longClickEvents = 0
          }
        }, 300)
      }
    },

    unlock() {
      this.isUnlocked = true
      if (this.redirectTo) {
        window.location = this.redirectTo
      }
    },
  },

  computed: {
    unLocking() {
      return this.longClickEvents > 1
    },
  },
}
</script>

<style scoped>

</style>